/*
 *  -----------------------------------------------------------------------
 *    <copyright file="opra-review/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import cn from 'clsx';
import React, { useEffect } from 'react';

import { OpraReviewProps } from '@components/core/opra-review/opra-review.interface';
import { useTranslation } from 'hooks';
import ItemWrapper from 'views/components/core/item-wrapper';
import './styles.scss';

const OpraReview = ({ datasetDate, action, data, onInit }: OpraReviewProps) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (onInit) {
            onInit();
        }
    }, []);

    return (
        <ItemWrapper
            title={t('cm:datasetDateValue', { date: datasetDate })}
            className="opra-review"
            hideItemNumber
            singleActionButton={action}
        >
            <div className="review-wrap">
                {data.map(({ label, text, scrollable }, index) => (
                    <>
                        <span key={label} className={cn('review-item', { 'review-item--scrollable': scrollable })}>
                            <span className="title">{label}:</span>
                            {text}
                        </span>
                        {index % 2 !== 0 && <div className="line-break" />}
                    </>
                ))}
            </div>
        </ItemWrapper>
    );
};

export default OpraReview;
